import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import useMemberTable from '../context/MemberTableContext'
import { QueryClient, useQuery } from '@tanstack/react-query'
import Loader from '../../../../common/loader/Loader'
import Notice from '../../../../common/card/Notice'
import { performRequest } from '../../../../common/utils'
import PendingInvitesTable from './PendingInvitesTable'

const PendingInvites = ({ teamType }) => {

  const params = useParams()
  const teamId = params.team_id ?? 0
  const [ responseMessage, setResponseMessage ] = useState('')
  const { setRefetchPendingInvites, setSelectedUser, setSelectedModal, setSelectedBulkUser } = useMemberTable()

  const queryClient = new QueryClient()

  const {
    isLoading,
    isPending,
    isFetching,
    isError,
    error,
    refetch,
    data } = useQuery({
      queryKey: ['msync_get_team_pending_invites'],
      queryFn: requestTeamPendingInvites,
      refetchOnWindowFocus: false
    }, queryClient)

    async function requestTeamPendingInvites() {
      // const formData = new FormData()
      // formData.append('action', 'msync_get_team_pending_invites')
      // formData.append('team_id', teamId)
      // formData.append('team_type', teamType)
      // formData.append('nonce', group_dashboard.nonce_members)

      try {
        // const request = await performRequest(group_dashboard.ajaxurl, formData)
        // const res = await request.json()
        const res = await Tangible?.ajax('msync_get_team_pending_invites', {
          team_id: teamId,
          team_type: teamType
        })
        if (!res.success) {
          throw new Error( res.errors.shift() )
        }
        return res.team_pending_invites
      } catch (error) {
        console.log(error)
        setResponseMessage( error.toString() )
        return false
      }
    }

    useEffect(() => {
      setRefetchPendingInvites(() => refetch)
      setSelectedUser('')
      setSelectedModal('')
      setSelectedBulkUser('')
    }, [ refetch ])

    if( isLoading || isPending || isFetching ){
      return (
        <Loader type='spinner-dual-ring'/>
      )
    }
  
    if( isError ){
      return (
        <Notice> 
          <strong> { error.message } </strong> 
        </Notice>
      )
    }
    
  return (
    <>
      {
        responseMessage && responseMessage !== ''
        ? <Notice className="msync-table__notice"> 
            <strong>{ responseMessage }</strong> 
          </Notice>
        : data &&
          <PendingInvitesTable pendingInvitesData={ data } teamType={ teamType } />
      }
    </>
  )
}

export default PendingInvites
